import React from 'react';

// Hand-drawn arrow pointing down-right or right
export const HandArrow = ({ className = '', style = {} }) => (
  <svg
    viewBox="0 0 100 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`inline-block ${className}`}
    style={{ overflow: 'visible', ...style }}
  >
    <path
      d="M6 14C28 8 62 12 84 28"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M72 16L85.5 28.5L78 40"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Curved arrow pointing to CTA
export const CurvedArrow = ({ className = '', style = {} }) => (
  <svg
    viewBox="0 0 70 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`inline-block ${className}`}
    style={{ overflow: 'visible', ...style }}
  >
    <path
      d="M8 8C20 32 42 42 62 30"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M52 24L63 30L60 41"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Squiggly underline for emphasizing key phrases
export const SquigglyUnderline = ({ className = '', style = {} }) => (
  <svg
    viewBox="0 0 200 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-full block ${className}`}
    preserveAspectRatio="none"
    style={{ overflow: 'visible', ...style }}
  >
    <path
      d="M3 10C24 4 48 14 70 8C92 3 116 13 138 7C160 3 182 12 197 7"
      stroke="currentColor"
      strokeWidth="3.2"
      strokeLinecap="round"
    />
  </svg>
);

// Hand-drawn circle / oval ring around key text with spacious, generous area
export const HighlightCircle = ({ className = '', children }) => (
  <span className={`relative inline-block px-5 py-2.5 mx-1 my-1.5 ${className}`}>
    <span className="relative z-10 font-bold">{children}</span>
    <svg
      viewBox="0 0 380 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute -inset-x-3 -inset-y-2 w-[calc(100%+24px)] h-[calc(100%+16px)] pointer-events-none text-[#C07A22]"
      preserveAspectRatio="none"
    >
      <path
        d="M24 36 C18 12, 85 4, 190 4 C295 4, 362 12, 358 36 C354 60, 295 68, 190 68 C85 68, 22 60, 22 36 C22 18, 75 6, 180 5"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  </span>
);

// Sparkle Star ✦
export const SparkleIcon = ({ className = '', style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={`inline-block ${className}`}
    style={{ ...style }}
  >
    <path d="M12 0C12 6.627 6.627 12 0 12C6.627 12 12 17.373 12 24C12 17.373 17.373 12 24 12C17.373 12 12 6.627 12 0Z" />
  </svg>
);

// Organic 4-point star burst
export const BurstStar = ({ className = '', style = {} }) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`inline-block ${className}`}
    style={{ ...style }}
  >
    <path
      d="M16 2V30M2 16H30M6 6L26 26M26 6L6 26"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);
